import React from "react";
import "./Policies.css";

const RefundPolicy = () => {
  return (
    <div className="policy-wrapper">
      <div className="policy-container">
        <div className="policy-header">
          <h1>Refund Policy</h1>
          <p>Effective Date: January 1, 2025</p>
        </div>

        <div className="policy-content">
          <p>
            At HexaPlay, we strive to provide a seamless and premium entertainment
            experience. This Refund Policy outlines the conditions under which
            refunds may be granted.
          </p>

          <h2>1. Booking Payments</h2>
          <p>
            All bookings made through HexaPlay are subject to confirmation and
            availability. Payments made for confirmed bookings are considered final
            unless cancellation conditions are met.
          </p>

          <h2>2. Refund Eligibility</h2>
          <ul>
            <li>Technical issues caused by HexaPlay.</li>
            <li>Service unavailability due to operational reasons.</li>
            <li>Duplicate payments or billing errors.</li>
          </ul>

          <h2>3. Non‑Refundable Situations</h2>
          <ul>
            <li>Last-minute cancellations.</li>
            <li>No-shows.</li>
            <li>Failure to follow venue policies.</li>
          </ul>

          <h2>4. Processing Time</h2>
          <p>
            Approved refunds will be processed within 7–10 business days through
            the original method of payment.
          </p>

          <h2>5. Contact</h2>
          <p>
            For refund inquiries, please contact our support team at
            support@hexaplay.com.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;